import React, { Component } from 'react'
import "./index.less"

import _ws from '@netuno/ws-client';

import Core from '../../Core';

export default class Cities extends Component {
  constructor(props) {
    super(props)
    this.state = {
      cities: [],
      isModalVisible: false,
      selectedCityUid: null
    }

    this.getCities = this.getCities.bind(this);
    this.handleChangeSelectedCityUid = this.handleChangeSelectedCityUid.bind(this);
  }

  getCities(term) {
    this.listenerGetCities = _ws.addListener({
      service: 'remote/city',
      success: (res) => {
        if (term !== "") {
          this.setState({ cities: res.content.filter((city) => city.name.toLowerCase().indexOf(term.toLowerCase()) === 0) })
        } else {
          this.setState({ cities: res.content })
        }
      },
      fail: (error) => {
        console.log(error)
      }
    });

    _ws.sendService({
      service: 'remote/city',
      data: { term }
    });

  }
  componentDidMount() {
    Core.getContext({
      onSuccess: async () => {
        const metadata = Core.data().metadata;
        console.log("METADATA");
        console.log(metadata);

        this.setState({ selectedCityUid: metadata.cityUid });
      },
      onFail: (data) => {
        console.log("Context data failed.", data);
      }
    });

    this.getCities("")

    _ws.sendService({
      service: 'ws/remote/command',
      data: {
        type: JSON.stringify({
          type: "cities",
          city_uid: "",
          price_min: "",
          price_max: "",
        })
      }
    });

  };

  componentWillUnmount() {
    _ws.removeListener(this.listenerGetCities);
  }

  async handleChangeSelectedCityUid(uid) {
    let cityUid = uid;

    /**if (uid === this.state.selectedCityUid) {
      cityUid = "";
    }*/

    this.setState({ selectedCityUid: cityUid })

    const setMetadata = await this.props.addMetadata("cityUid", cityUid);

    if (setMetadata) {
      this.props.handleSubmit();
    }
  }

  render() {
    const { cities } = this.state;

    return (
      <div className="cities">
        {this.state.isModalVisible ?
          (
            <div className="modal">
              <button onClick={() => { this.setState({ isModalVisible: false }); this.getCities("") }} className="close-btn">
                <img src="./icons/close.png" alt="close" />
              </button>
              <input onChange={e => this.getCities(e.target.value)} placeholder="Procure um concelho" type="text" />
              <div className="search-cities">
                {cities.map(city => {
                  return (
                    <button
                      onClick={() => this.handleChangeSelectedCityUid(city.uid)}
                      key={city.uid}
                      className="city">
                      <span>{city.name}</span>
                    </button>
                  )
                })}
              </div>
            </div>
          )
          : (
            <>
              {cities.map(city => {
                return (
                  <button
                    onClick={() => this.handleChangeSelectedCityUid(city.uid)}
                    key={city.uid}
                    className="city">
                    <span>{city.name}</span>
                    {/* <div className="img" style={{ backgroundImage: "url(https://www.eurodicas.com.br/wp-content/uploads/2019/12/cidade-de-oeiras.jpg)" }}></div> */}
                  </button>
                )
              })}
              <div className="others-btn">
                <hr />
                <button
                  onClick={() => {
                    this.setState({ isModalVisible: true })
                  }}>
                  <img src="./icons/plus.png" alt="Outras cidades" />
                </button>
                <hr />
              </div>
            </>
          )}
      </div>
    )
  }
}
